module.exports = __webpack_public_path__ + "img/knowledge.125d54a0.png";